import { forwardRef, Fragment } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconThumbsUp } from 'src/assets/icons/IconThumbsUp';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import useStyles from './useStyles';

export const RatingsScore = forwardRef(({ score, number, threshold, negative }, ref) => {
  const styles = useStyles();

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.root}
        ref={ref}
        data-testid="promptScore"
      >
        <Fragment>
          <CircularProgress
            classes={{
              root: styles.circleBgRoot,
              circle: styles.circleBgCircle,
            }}
            size={'64px'}
            variant="determinate"
            value={100}
          />

          <CircularProgress
            classes={{
              root: styles.circleRoot,
              circle: styles.circleCircle,
            }}
            size={'64px'}
            variant="determinate"
            value={Math.min(score, 99)}
          />
        </Fragment>
      </div>{' '}
      <div className={styles.progressNumber}>
        {Math.min(number, 99)}
        {number < threshold && (
          <CustomTypography
            className={styles.progressOutOf}
            variant={TYPOGRAPHY_VARIANT.medium12}
          >
            /{threshold}
          </CustomTypography>
        )}
      </div>
      <div className={styles.progressLineLabel}>
        <Divider className={styles.progressLine} />
      </div>
      <div className={styles.progressInfo}>
        <div className={styles.progressCount}>
          <IconThumbsUp
            className={cx(styles.progressIcon, negative ? styles.thumbsDownIcon : '')}
          />
        </div>
      </div>
    </div>
  );
});

RatingsScore.propTypes = {
  score: PropTypes.number,
  number: PropTypes.number,
  threshold: PropTypes.number,
  negative: PropTypes.bool,
};

RatingsScore.defaultProps = {
  score: null,
  number: null,
  threshold: null,
  negative: false,
};
